import * as React from 'react';

import * as styles from './RecommendationsLayout.css';

interface IProps {
  children: React.ReactNode;
}

export const RecommendationsLayout = ({ children }: IProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
